// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import {Base64} from 'js-base64'
// main.js
// NutUI框架引入
import Swiper from "@nutui/nutui/dist/packages/swiper/swiper.js";
import Toast from "@nutui/nutui/dist/packages/toast/toast.js";
import '@nutui/nutui/dist/packages/swiper/swiper.css';
import '@nutui/nutui/dist/packages/toast/toast.css';
Swiper.install(Vue);
Toast.install(Vue);

//vant
import  Tabbar from 'vant/lib/tabbar';
import  TabbarItem from 'vant/lib/tabbar-item';
import Pagination  from 'vant/lib/pagination';
import 'vant/lib/tabbar/style'
import 'vant/lib/tabbar-item/style'
import 'vant/lib/pagination/style'
Vue.use(Tabbar).use(TabbarItem).use(Pagination)

// router处理
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

import * as api from "./api";
Vue.prototype.$Base64=Base64;
Vue.prototype.$api=api;
// 复制到剪切板
 
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js